import { ChangeDetectorRef, Component, DestroyRef, ElementRef, EventEmitter, HostListener, inject, Input, NgZone, OnChanges, OnDestroy, OnInit, Output, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { AngularMultiSelect } from 'angular2-multiselect-dropdown';

import { faChevronDown, faChevronUp, faDownload, faFilter, faQrcode } from '@fortawesome/pro-regular-svg-icons';
import { faCalendarAlt, faFileDownload, faPrint, faSearch } from '@fortawesome/pro-solid-svg-icons';

import { BreakpointObserver } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import * as _ from 'underscore';
import { BlockCustomFieldDTO } from '../../models/block';
import { Room } from '../../models/storage/room';
import { TenantWordsPipe } from '../../pipes/tenant-words.pipe';
import { KwFilterDropdownService } from './kw-filter-dropdown.service';
import { FilterSettings } from './models/filter-options';
import { FilterResults } from './models/filter-results';
import { FilterItem } from './models/kw-filter-item';




@Component({
  selector: 'kw-filter-dropdown',
  templateUrl: './kw-filter-dropdown.component.html',
  styleUrls: ['./kw-filter-dropdown.component.scss']
})
export class KwFilterDropdownComponent implements OnInit, OnChanges, OnDestroy {

  @Output() resetDropdowns: EventEmitter<void> = new EventEmitter();

  private destroyRef = inject(DestroyRef);
  private elementRef = inject(ElementRef);

  public blockFilterText: string = ''; // Variable for block search text
  public roomFilterText: string = ''; // Variable for room search text
  public locationFilterText: string = ''; // Variable for location search text
  public fieldmanFilterText: string = ''; // Variable for fieldman search text
  public estimateTypeFilterText: string = ''; // Variable for estimate type search text

  filtersExpanded = true;
  // Function to be called when the reset button is clicked
  onResetButtonClick() {
    // Emit the custom event to the parent component
    this.resetDropdowns.emit();
    this.filterService.resetDropdowns(true)
  }
  private filterServiceSubscription: Subscription;
  public isLoading = true;

  public checked = true;

  constructor(
    public filterService: KwFilterDropdownService,
    private pipe: TenantWordsPipe,
    private http: HttpClient,
    private changeDetector: ChangeDetectorRef,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private ngZone: NgZone
  ) {
    this.checked = this.filterService.bypassFilterReset;
  }


  ngOnDestroy(): void {
    if (this.filterServiceSubscription)
      this.filterServiceSubscription.unsubscribe();
    document.removeEventListener('scroll', this.closeOnNestedScroll, true);
  }

  ngAfterViewChecked(): void {
    this.changeDetector.detectChanges();
  }

  onSearchTextChanged(searchType: string) {


    if (searchType == "Block") {
      this.filterService.listOfBlocks = [];
      this.filterService.listOfBlocks = this.filterService.allBlocks.filter((block) => {
        return block.name.toLowerCase().includes(this.blockFilterText.toLowerCase());
      }).map(item => <FilterItem>{
        id: item.id,
        itemName: item.name,
        group: item.farmName
      });
    }

    if (searchType == "Room") {
      this.filterService.listOfRooms = [];
      this.filterService.listOfRooms = this.filterService.allRooms.filter((room) => {
        return room.name.toLowerCase().includes(this.roomFilterText.toLowerCase());
      }).map(item => <FilterItem>{
        id: item.id,
        itemName: item.name,
        group: item.warehouse.name
      });
    }

    if (searchType == "Location") {
      this.filterService.listOfLocations = [];
      this.filterService.listOfLocations = this.filterService.allLocations.filter((location) => {
        return location.name.toLowerCase().includes(this.locationFilterText.toLowerCase());
      }).map(item => <FilterItem>{
        id: item.id,
        itemName: item.name,
        group: item.room.name
      });
    }

    if (searchType == "EstimateType") {
      this.filterService.listOfEstimateTypes = [];
      this.filterService.listOfEstimateTypes = this.filterService.allEstimateTypes.filter((estimateType) => {
        return estimateType.name.toLowerCase().includes(this.estimateTypeFilterText.toLowerCase());
      }).map(item => <FilterItem>{
        id: item.id,
        itemName: item.name
      });
    }

    if (searchType == "Fieldman") {

      let fieldmanMap = [...this.filterService.allBlocks]
        .filter(x =>
        (
          (this.filterService.selectedFarms.map(y => y.id).includes(x.farmId) || this.filterService.selectedFarms.length == 0) &&
          (this.filterService.selectedVarieties.map(y => y.id).includes(x.varietyId) || this.filterService.selectedVarieties.length == 0) &&
          (this.filterService.selectedFieldmen.map(y => y.id).includes(x.fieldman || '') || this.filterService.selectedFieldmen.length == 0) &&
          (this.filterService.selectedBlocks.map(y => y.id).includes(x.id) || this.filterService.selectedBlocks.length == 0))
        )
        .map(x => {
          return {
            id: x.fieldman,
            itemName: x.fieldman || 'None',
          };
        });

      let uniqFieldmans = _.uniq(fieldmanMap, x => x.id);
      this.filterService.listOfFieldmen = _.chain(uniqFieldmans).sortBy(x => x.itemName).sortBy(x => x.itemName).value().filter((fieldman) => {
        return fieldman.itemName.toLowerCase().includes(this.fieldmanFilterText.toLowerCase());
      }).map(item => <FilterItem>{
        id: item.id,
        itemName: item.itemName
      });
    }

  }

  eventFilterChange(event: any) {
    this.filterService.filter();

    if (event == "Block")
      this.filterService.listOfBlocks = this.filterService.allBlocks.filter((block) => {
        return block.name.toLowerCase().includes(this.blockFilterText.toLowerCase()) &&
          (this.filterService.selectedFarms.map(y => y.id).includes(block.farmId) || this.filterService.selectedFarms.length == 0) &&
          (this.filterService.selectedVarieties.map(y => y.id).includes(block.varietyId) || this.filterService.selectedVarieties.length == 0) &&
          (this.filterService.selectedFieldmen.map(y => y.id).includes(block.fieldman || '') || this.filterService.selectedFieldmen.length == 0);
      }).map(item => <FilterItem>{
        id: item.id,
        itemName: item.name + "(" + item.varietyName + ")",
        group: item.farmName
      });

    else if (event == "Room")
      this.filterService.listOfRooms = this.filterService.allRooms.filter((room) => {
        return room.name.toLowerCase().includes(this.roomFilterText.toLowerCase()) &&
          (this.filterService.selectedWarehouses.map(y => y.id).includes(room.warehouseId) || this.filterService.selectedWarehouses.length == 0);
      }).map(item => <FilterItem>{
        id: item.id,
        itemName: item.name,
        group: item.warehouse.name
      });

    if (event == "Location")
      this.filterService.listOfLocations = this.filterService.allLocations.filter((location) => {
        return location.name.toLowerCase().includes(this.locationFilterText.toLowerCase()) &&
          (this.filterService.selectedRooms.map(y => y.id).includes(location.roomId) || this.filterService.selectedRooms.length == 0);
      }).map(item => <FilterItem>{
        id: item.id,
        itemName: item.name,
        group: item.room.name
      });

    if (event == "EstimateType")
      this.filterService.listOfEstimateTypes = this.filterService.listOfEstimateTypes.filter((estimateType) => {
        return estimateType.itemName.toLowerCase().includes(this.estimateTypeFilterText.toLowerCase());
      }).map(item => <FilterItem>{
        id: item.id,
        itemName: item.itemName,
        group: item.group
      });

    if (event == "Fieldman") {

      let fieldmanMap = [...this.filterService.allBlocks]
        .filter(x =>
        (
          (this.filterService.selectedFarms.map(y => y.id).includes(x.farmId) || this.filterService.selectedFarms.length == 0) &&
          (this.filterService.selectedVarieties.map(y => y.id).includes(x.varietyId) || this.filterService.selectedVarieties.length == 0) &&
          (this.filterService.selectedFieldmen.map(y => y.id).includes(x.fieldman || '') || this.filterService.selectedFieldmen.length == 0) &&
          (this.filterService.selectedBlocks.map(y => y.id).includes(x.id) || this.filterService.selectedBlocks.length == 0))
        )
        .map(x => {
          return {
            id: x.fieldman,
            itemName: x.fieldman || 'None',
          };
        });

      let uniqFieldmans = _.uniq(fieldmanMap, x => x.id);
      this.filterService.listOfFieldmen = _.chain(uniqFieldmans).sortBy(x => x.itemName).sortBy(x => x.itemName).value().filter((fieldman) => {
        return fieldman.itemName.toLowerCase().includes(this.fieldmanFilterText.toLowerCase());
      }).map(item => <FilterItem>{
        id: item.id,
        itemName: item.itemName
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // When the host page hides the crop selector, the variety dropdown should
    // not be silently scoped to the default crop (see KwFilterDropdownService.cropFilterVisible).
    this.filterService.cropFilterVisible = !!(this.filterSettings.cropSettings && this.filterSettings.cropSettings.display);

    if (this.filterSettings.storageSettings)
      this.storageTypesDropdownSettings.singleSelection = this.filterSettings.storageSettings.singleSelection;

    if (this.filterSettings.workOrderSettings)
      this.workOrderTypeDropdownSettings.singleSelection = this.filterSettings.workOrderSettings.singleSelection;

    if (this.filterSettings.groupingSettings)
      this.groupingDropdownSettings.singleSelection = this.filterSettings.groupingSettings.singleSelection;

    if (this.filterSettings.poolTypeSettings)
      this.poolDropdownSettings.singleSelection = this.filterSettings.poolTypeSettings.singleSelection;

    if (this.filterSettings.farmSettings)
      this.farmDropdownSettings.singleSelection = this.filterSettings.farmSettings.singleSelection;

    if (this.filterSettings.blockSettings) {
      if (this.filterSettings.blockSettings.singleSelection) {
        this.blockDropdownSettings.groupBy = '';
      }
      this.blockDropdownSettings.singleSelection = this.filterSettings.blockSettings.singleSelection;
    }

    if (this.filterSettings.fieldmanSettings)
      this.fieldmenDropdownSettings.singleSelection = this.filterSettings.fieldmanSettings.singleSelection;

    if (this.filterSettings.cropYearSettings)
      this.cropYearDropdownSettings.singleSelection = this.filterSettings.cropYearSettings.singleSelection;

    if (this.filterSettings.varietySettings)
      this.varietyDropdownSettings.singleSelection = this.filterSettings.varietySettings.singleSelection;

    if (this.filterSettings.organicConventionalSettings)
      this.organicConventionalDropdownSettings.singleSelection = this.filterSettings.organicConventionalSettings.singleSelection;

    if (this.filterSettings.cropSettings)
      this.cropDropdownSettings.singleSelection = this.filterSettings.cropSettings.singleSelection;

    if (this.filterSettings.customerSettings)
      this.customerDropdownSettings.singleSelection = this.filterSettings.customerSettings.singleSelection;

    if (this.filterSettings.dateRangeSettings)
      this.dateRangeSettings.singleSelection = this.filterSettings.dateRangeSettings.singleSelection;

    if (this.filterSettings.qcAreaSettings)
      this.qcAreasDropdownSettings.singleSelection = this.filterSettings.qcAreaSettings.singleSelection;

    if (this.filterSettings.warehouseSettings)
      this.warehouseDropdownSettings.singleSelection = this.filterSettings.warehouseSettings.singleSelection;

    if (this.filterSettings.inventoryItemSettings)
      this.inventoryItemDropdownSettings.singleSelection = this.filterSettings.inventoryItemSettings.singleSelection;

    if (this.filterSettings.locationSettings)
      this.locationDropdownSettings.singleSelection = this.filterSettings.locationSettings.singleSelection;

    if (this.filterSettings.lotNumberSettings)
      this.lotNumberDropdownSettings.singleSelection = this.filterSettings.lotNumberSettings.singleSelection;

    if (this.filterSettings.roomSettings)
      this.roomDropdownSettings.singleSelection = this.filterSettings.roomSettings.singleSelection;

    if (this.filterSettings.estimateTypeSettings)
      this.estimateTypeDropdownSettings.singleSelection = this.filterSettings.estimateTypeSettings.singleSelection;

    if (this.filterSettings.shipmentStatusSettings)
      this.shipmentStatusDropdownSettings.singleSelection = this.filterSettings.shipmentStatusSettings.singleSelection;

    if (this.filterSettings.carrierSettings)
      this.shipmentStatusDropdownSettings.singleSelection = this.filterSettings.carrierSettings.singleSelection;

    if (this.filterSettings.truckTypeSettings)
      this.shipmentStatusDropdownSettings.singleSelection = this.filterSettings.truckTypeSettings.singleSelection;

    if (this.filterSettings.featureEventTypeSettings)
      this.shipmentStatusDropdownSettings.singleSelection = this.filterSettings.featureEventTypeSettings.singleSelection;

    this.setDates();

  }

  ngOnInit() {
    document.addEventListener('scroll', this.closeOnNestedScroll, true);

    if (this.filterSettings.includeCompletedSettings)
      this.includeCompletedSettings.text = this.filterSettings.includeCompletedSettings.label;

    if (!this.filterService.hasLoaded)
      this.filterService.loadAllData();
    else
      this.filterService.setDropdownLists();

    this.isLoading = this.filterService.isLoading;

    if (this.filterSettings.dateRangeSettings === undefined) {
      this.filterSettings.dateRangeSettings = {
        display: false,
        singleSelection: false,
      };
    }

    // Only apply default dates from filterSettings if we don't have saved dates
    var hasSavedDates = this.filterService.bypassFilterReset &&
      this.filterService.selectedDates &&
      this.filterService.selectedDates[0] !== null;

    if (!hasSavedDates && this.filterSettings.dateRangeSettings.startDate && this.filterSettings.dateRangeSettings.endDate) {
      let startDate = this.filterSettings.dateRangeSettings.startDate;
      let endDate = this.filterSettings.dateRangeSettings.endDate;
      this.filterService.selectedDates = [startDate, endDate];
    } else {
      // let startDate = moment(new Date()).subtract(0, 'days').toDate();
      // let endDate = moment(new Date()).add(7, 'days').toDate();
      // this.filterService.selectedDates = [startDate, endDate];
    }

    this.setDates();
    setTimeout(() => {
      for (let dropdown of this.allDropDownsettings) {
        dropdown.noDataLabel = "No Data"
      }

      this.filterServiceSubscription = this.filterService.itemChanged.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {

        if (this.filterService.hasLoaded) {
          this.filterResultsChange.emit(this.filterService.filterResults);
        }
      });
    }, 0);
  }

  onCheckboxChange(event: any): void {
    this.checked = event.checked;
    this.filterService.onCheckboxChange(this.checked);
  }

  private setDates() {
    // Skip overriding dates if we have saved dates and retain filters is checked
    var hasSavedDates = this.filterService.bypassFilterReset &&
      this.filterService.selectedDates &&
      this.filterService.selectedDates[0] !== null;

    if (hasSavedDates) {
      return;
    }

    if (this.filterSettings && this.filterSettings.dateRangeSettings) {
      if (this.filterSettings.dateRangeSettings.startDate) {
        this.filterService.selectedDates = [this.filterSettings.dateRangeSettings.startDate, this.filterService.selectedDates[1]]
      }

      if (this.filterSettings.dateRangeSettings.endDate)
        this.filterService.selectedDates = [this.filterService.selectedDates[0], this.filterSettings.dateRangeSettings.endDate];
    }

  }

  public GetBlockCustomFieldSettings(field: BlockCustomFieldDTO) {
    let custSettings: any = { ...this.blockCustomFieldDropdownSettings };

    custSettings.text =
      this.pipe.transform("Block") + " " + field.name;

    custSettings.dynamicTitleMaxItems = 1;
    custSettings.enableCheckAll = true;
    custSettings.classes = 'block-custom-dropdown';
    return custSettings;
  }

  // Corrects a just-opened popup's position using its real rendered height,
  // since the library's own autoPosition assumes a fixed settings.maxHeight.
  // Scoped to the single control that was clicked (never queries other dropdowns).
  private correctDropdownPosition(hostEl: HTMLElement): void {
    requestAnimationFrame(() => {
      const dropdownList = hostEl.querySelector('.dropdown-list') as HTMLElement;
      const trigger = hostEl.querySelector('.selected-list') as HTMLElement;

      if (!dropdownList || !trigger || dropdownList.hidden) {
        return;
      }

      const triggerRect = trigger.getBoundingClientRect();
      const popupHeight = dropdownList.getBoundingClientRect().height;
      const spaceBelow = window.innerHeight - triggerRect.bottom;
      const spaceAbove = triggerRect.top;

      if (spaceBelow < popupHeight && spaceAbove > spaceBelow) {
        dropdownList.style.top = (triggerRect.top - popupHeight) + 'px';
        dropdownList.style.bottom = 'auto';
      } else {
        dropdownList.style.top = triggerRect.bottom + 'px';
        dropdownList.style.bottom = 'auto';
      }

      dropdownList.style.left = triggerRect.left + 'px';
      dropdownList.style.width = triggerRect.width + 'px';
    });
  }

  @HostListener('click', ['$event'])
  onFilterHostClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const trigger = target.closest('.c-btn');
    if (!trigger) {
      return;
    }

    const hostEl = target.closest('angular2-multiselect') as HTMLElement;
    if (hostEl) {
      this.correctDropdownPosition(hostEl);
    }
  }

  // scroll doesn't bubble to window, so the library's own window:scroll close
  // handler never fires when an ancestor panel (not the page) is scrolled.
  private closeOnNestedScroll = (event: Event): void => {
    if (!(event.target instanceof HTMLElement)) {
      return;
    }

    const hostElement: HTMLElement = this.elementRef.nativeElement;
    hostElement.querySelectorAll('angular2-multiselect').forEach((hostEl: Element) => {
      const dropdownList = hostEl.querySelector('.dropdown-list') as HTMLElement;
      if (dropdownList && !dropdownList.hidden && !dropdownList.contains(event.target as Node)) {
        const trigger = hostEl.querySelector('.c-btn') as HTMLElement;
        if (trigger) {
          trigger.click();
        }
      }
    });
  };




  @Output() cropYear = new EventEmitter<FilterItem>();
  @Input() filterSettings: FilterSettings;
  @Input() stack: boolean = false;
  @Input() gridCountDataAndMessage:any;
  @Output() downloadFiles = new EventEmitter<string>();
  filterResults: FilterResults = {
    selectedBlocks: [],
    selectedCropYears: [],
    selectedFarms: [],
    selectedFieldmen: [],
    selectedVarieties: [],
    selectedOrganConventional: [],
    selectedDateRange: [],
    selectedQcAreas: [],
    includeCompleted: false,
    selectedCarriers: [],
    selectedTruckTypes: [],
    selectedLoad: "",
    selectedInventoryItems: [],
    selectedLocations: [],
    selectedLotNumbers: [],
    selectedBreweries: [],
    selectedUserNames: [],
    selectedFeatureEventTypes: [],
    selectedGrouping: [],
    selectedPools: [],
    selectedStorageTypes: [],
    selectedCustomers: [],
    barcode: "",
  };


  @Output()
  filterResultsChange = new EventEmitter<FilterResults>();

  @Output()
  onChange = new EventEmitter<any>();

  @Output()
  exportPressed = new EventEmitter<any>();

  // Icons
  faCalendarAlt = faCalendarAlt;
  faDownload = faDownload;
  faFilter=faFilter;
  faQrcode = faQrcode;
  faChevronUp=faChevronUp;
  faChevronDown = faChevronDown ;


  public dateRangeSettings = {
    singleSelection: false,
    text: this.pipe.transform("Farm") + "s",
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    noDataLabel: "No data found",
    badgeShowLimit: 1,
  };

  public farmDropdownSettings = {
    singleSelection: false,
    text: this.pipe.transform("Farm") + "s",
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    noDataLabel: "No data found",
    badgeShowLimit: 1,
  };

  public workOrderTypeDropdownSettings = {
    singleSelection: false,
    text: this.pipe.transform("Work Order Type"),
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    noDataLabel: "No data found",
    badgeShowLimit: 1,
  };

  public groupingDropdownSettings = {
    singleSelection: true,
    text: "Group By",
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public blockDropdownSettings = {
    singleSelection: false,
    text: this.pipe.transform("Block"),
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    groupBy: 'group',
    classes: "",
    noDataLabel: "Loading",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public poolDropdownSettings = {
    singleSelection: false,
    text: this.pipe.transform("Pool"),
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    groupBy: 'group',
    classes: "",
    noDataLabel: "Loading",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public blockCustomFieldDropdownSettings = {
    singleSelection: false,
    text: this.pipe.transform("Block") + " Custom Fields",
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    noDataLabel: "Loading",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public featureEventTypesDropdownSettings = {
    singleSelection: false,
    text: this.pipe.transform('Asset') + 'Event Type',
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    // groupBy: 'group',
    classes: "",
    noDataLabel: "Loading",
    badgeShowLimit: 1,
    lazyLoading: false,
  };


  public featureTypesDropdownSettings = {
    singleSelection: false,
    text: this.pipe.transform('Asset') + ' Type',
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    // groupBy: 'group',
    classes: "",
    noDataLabel: "Loading",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public featureDropdownSettings = {
    singleSelection: false,
    text: this.pipe.transform('Asset'),
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    // groupBy: 'group',
    classes: "",
    noDataLabel: "Loading",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public selectedRooms: FilterItem[] = [];
  //public selectedBlocks: FilterItem[] = [];
  public listOfRooms: FilterItem[] = [];
  public allRooms: Room[] = [];
  public roomDropdownSettings = {
    singleSelection: false,
    text: this.pipe.transform("Room"),
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    groupBy: 'group',
    classes: "",
    noDataLabel: "Loading",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public warehouseDropdownSettings = {
    singleSelection: false,
    text: this.pipe.transform("Warehouse"),
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    noDataLabel: "Loading",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public inventoryItemDropdownSettings = {
    singleSelection: false,
    text: this.pipe.transform("Product"),
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    noDataLabel: "Loading",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public locationDropdownSettings = {
    singleSelection: false,
    text: this.pipe.transform("Location"),
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    noDataLabel: "Loading",
    badgeShowLimit: 1,
    groupBy: 'group',
    lazyLoading: false,
  };

  public lotNumberDropdownSettings = {
    singleSelection: false,
    text: this.pipe.transform("Lot Number"),
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    noDataLabel: "Loading",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public estimateTypeDropdownSettings = {
    singleSelection: true,
    text: this.pipe.transform("Estimate") + ' Type',
    enableSearchFilter: true,
    classes: "",
    noDataLabel: "No data found",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public varietyDropdownSettings = {
    singleSelection: false,
    text: this.pipe.transform("Variety"),
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public fieldEventDropdownSettings = {
    singleSelection: false,
    text: this.pipe.transform("Scouting Type"),
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public fieldmenDropdownSettings = {
    singleSelection: false,
    text: "Fieldman",
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public userNameDropdownSettings = {
    singleSelection: false,
    text: "User",
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public breweryDropdownSettings = {
    singleSelection: false,
    text: "Brewery",
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    badgeShowLimit: 1,
    lazyLoading: false,
  };
  public carrierDropdownSettings = {
    singleSelection: false,
    text: "Carrier",
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public truckTypeDropdownSettings = {
    singleSelection: false,
    text: "Truck Type",
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public loadDropdownSettings = {
    singleSelection: true,
    text: "Load Number",
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public cropDropdownSettings = {
    singleSelection: true,
    text: "Crop",
    // selectAllText: 'Select All',
    // unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public customerDropdownSettings = {
    singleSelection: true,
    text: this.pipe.transform("Customer"),
    // selectAllText: 'Select All',
    // unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public barcodeDropdownSettings = {
    singleSelection: false,
    text: "Barcode",
    enableSearchFilter: true,
    classes: "",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public typesDropdownSettings = {
    singleSelection: false,
    text: "Scouting Type",
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public storageTypesDropdownSettings = {
    singleSelection: false,
    text: "Storage Type",
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public shipmentStatusDropdownSettings = {
    singleSelection: false,
    text: "Shipment Status",
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public cropYearDropdownSettings = {
    text: "Crop Year",
    enableSearchFilter: true,
    singleSelection: true,
    noDataLabel: "No crop years for selected crop",
    classes: "",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public organicConventionalDropdownSettings = {
    singleSelection: false,
    text: this.pipe.transform("Org./Conv."),
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  public includeCompletedSettings = {
    singleSelection: true,
    text: "Include Completed?",
    enableSearchFilter: false,
    classes: "my-custom-dropdown",
    lazyLoading: false,
  };

  public qcAreasDropdownSettings = {
    singleSelection: false,
    text: "Qc Area",
    selectAllText: 'Select All',
    unSelectAllText: 'Clear All',
    enableSearchFilter: true,
    classes: "",
    badgeShowLimit: 1,
    lazyLoading: false,
  };

  // icons 
  public faFileDownload = faFileDownload;
  public faPrint = faPrint;
  public faSearch = faSearch;


  private allDropDownsettings: any[] = [
    this.farmDropdownSettings,
    this.blockDropdownSettings,
    this.varietyDropdownSettings,
    this.cropYearDropdownSettings,
    this.fieldmenDropdownSettings,
    this.carrierDropdownSettings,
    this.truckTypeDropdownSettings,
    this.poolDropdownSettings,
    this.storageTypesDropdownSettings,
    this.warehouseDropdownSettings,
    this.inventoryItemDropdownSettings,
    this.locationDropdownSettings,
    this.lotNumberDropdownSettings,
    this.roomDropdownSettings
  ]

  // Keyboard navigation properties
  private currentFocusedDropdown: string = '';
  private currentFocusedIndex: number = -1;

  // Handle keyboard events for dropdown navigation
  @HostListener('keydown', ['$event'])
  handleKeydown(event: KeyboardEvent): void {
    const target = event.target as HTMLElement;
    
    
    // Check if the target is within an angular2-multiselect component
    const multiselectElement = target.closest('angular2-multiselect') as HTMLElement;
    if (multiselectElement) {
      const dropdownId = multiselectElement.getAttribute('id');
      
      if (dropdownId) {
        this.handleDropdownKeydown(event, dropdownId, multiselectElement);
      }
    }
  }

  private handleDropdownKeydown(event: KeyboardEvent, dropdownId: string, dropdownElement: HTMLElement): void {
    const key = event.key;
    
    
    switch (key) {
      case 'Enter':
        event.preventDefault();
        
        this.handleEnter(dropdownId, dropdownElement);
        break;
      case 'ArrowDown':
        event.preventDefault();
        
        this.handleArrowDown(dropdownId, dropdownElement);
        break;
      case 'ArrowUp':
        event.preventDefault();
        
        this.handleArrowUp(dropdownId, dropdownElement);
        break;
      case 'Escape':
        
        this.handleEscape(dropdownId, dropdownElement);
        break;
      case ' ':
        // Let spacebar pass through to search input - don't prevent default
        
        break;
    }
  }

  private handleEnter(dropdownId: string, dropdownElement: HTMLElement): void {
    
    
    // Try to find the dropdown button - based on console logs, it's a div with class c-btn
    const dropdownButton = dropdownElement.querySelector('.c-btn') as HTMLElement ||
                          dropdownElement.querySelector('.dropdown-btn') as HTMLElement ||
                          dropdownElement.querySelector('.multiselect-dropdown') as HTMLElement ||
                          dropdownElement.querySelector('[role="button"]') as HTMLElement;
    
    
    
    const dropdownList = dropdownElement.querySelector('.c-list') as HTMLElement ||
                        dropdownElement.querySelector('.dropdown-list') as HTMLElement ||
                        dropdownElement.querySelector('.multiselect-list') as HTMLElement ||
                        dropdownElement.querySelector('[role="listbox"]') as HTMLElement;
    
    
    
    if (dropdownButton) {
      const isOpen = dropdownList && dropdownList.style.display !== 'none' && dropdownList.offsetHeight > 0;
      
      
      if (!isOpen) {
        // Open the dropdown
        
        dropdownButton.click();
        this.currentFocusedDropdown = dropdownId;
        this.currentFocusedIndex = 0;
        // Give more time for the dropdown to populate, then focus the search input
        setTimeout(() => {
          
          this.focusSearchInput(dropdownElement);
        }, 500);
      } else {
        // Select the currently focused item
        
        this.selectFocusedItem(dropdownId, dropdownElement);

        // After selection, keep focus on the dropdown button
        setTimeout(() => {
          try {
            dropdownButton.focus();
          } catch (error) {
            console.error('Error focusing dropdown button:', error);
          }
        }, 200);
      }
    } else {
      
    }
  }

  private handleArrowDown(dropdownId: string, dropdownElement: HTMLElement): void {
    
    
    const dropdownList = dropdownElement.querySelector('.c-list') as HTMLElement ||
                        dropdownElement.querySelector('.dropdown-list') as HTMLElement ||
                        dropdownElement.querySelector('.multiselect-list') as HTMLElement ||
                        dropdownElement.querySelector('[role="listbox"]') as HTMLElement;
    
    
    
    if (dropdownList && dropdownList.style.display !== 'none') {
      // Debug: Log the innerHTML to see what's actually in the dropdown
      
      
      // Try multiple selectors to find items - prioritize li elements since that's what we found
      const items = dropdownList.querySelectorAll('li.pure-checkbox, .c-option, .dropdown-item, .multiselect-item, [role="option"], li, .item, .option, .list-item');
      
      
      // If no items found, try to find any clickable elements
      if (items.length === 0) {
        const allElements = dropdownList.querySelectorAll('*');
        
        for (let i = 0; i < Math.min(allElements.length, 5); i++) {
          
        }
      }

      const maxIndex = items.length - 1;

      if (this.currentFocusedDropdown === dropdownId) {
        this.currentFocusedIndex = Math.min(this.currentFocusedIndex + 1, maxIndex);
      } else {
        this.currentFocusedIndex = 0;
        this.currentFocusedDropdown = dropdownId;
      }
      
      
      this.focusDropdownItem(dropdownElement, this.currentFocusedIndex);
    } else {
      
    }
  }

  private handleArrowUp(dropdownId: string, dropdownElement: HTMLElement): void {
    
    
    const dropdownList = dropdownElement.querySelector('.c-list') as HTMLElement ||
                        dropdownElement.querySelector('.dropdown-list') as HTMLElement ||
                        dropdownElement.querySelector('.multiselect-list') as HTMLElement ||
                        dropdownElement.querySelector('[role="listbox"]') as HTMLElement;
    
    
    
    if (dropdownList && dropdownList.style.display !== 'none') {
      const items = dropdownList.querySelectorAll('.c-option, .dropdown-item, .multiselect-item, [role="option"]');
      
      
      if (this.currentFocusedDropdown === dropdownId) {
        this.currentFocusedIndex = Math.max(this.currentFocusedIndex - 1, 0);
      } else {
        this.currentFocusedIndex = items.length - 1;
        this.currentFocusedDropdown = dropdownId;
      }
      
      
      this.focusDropdownItem(dropdownElement, this.currentFocusedIndex);
    } else {
      
    }
  }

  private handleEscape(dropdownId: string, dropdownElement: HTMLElement): void {
    
    
    const dropdownButton = dropdownElement.querySelector('.c-btn') as HTMLElement ||
      dropdownElement.querySelector('.dropdown-btn') as HTMLElement ||
      dropdownElement.querySelector('.multiselect-dropdown') as HTMLElement ||
      dropdownElement.querySelector('[role="button"]') as HTMLElement;

    const dropdownList = dropdownElement.querySelector('.c-list') as HTMLElement ||
      dropdownElement.querySelector('.dropdown-list') as HTMLElement ||
      dropdownElement.querySelector('.multiselect-list') as HTMLElement ||
      dropdownElement.querySelector('[role="listbox"]') as HTMLElement;

    if (dropdownList && dropdownList.style.display !== 'none') {
      // Close the dropdown
      
      if (dropdownButton) {
        dropdownButton.click();

        // Keep focus on the dropdown button after closing
        setTimeout(() => {
          try {
            dropdownButton.focus();
          } catch (error) {
            console.error('Error focusing dropdown button:', error);
          }
        }, 100);
      }
      this.currentFocusedDropdown = dropdownId; // Keep the dropdown as focused
      this.currentFocusedIndex = -1;
    }
  }

  private focusDropdownItem(dropdownElement: HTMLElement, index: number): void {
    
    
    const dropdownList = dropdownElement.querySelector('.c-list') as HTMLElement ||
                        dropdownElement.querySelector('.dropdown-list') as HTMLElement ||
                        dropdownElement.querySelector('.multiselect-list') as HTMLElement ||
                        dropdownElement.querySelector('[role="listbox"]') as HTMLElement;
    
    
    
    if (dropdownList) {
      // Use the same prioritized selectors as in handleArrowDown
      const items = dropdownList.querySelectorAll('li.pure-checkbox, .c-option, .dropdown-item, .multiselect-item, [role="option"], li, .item, .option, .list-item');
      
      
      if (items.length > 0 && index >= 0 && index < items.length) {
        const item = items[index] as HTMLElement;
        
        
        // Try to focus the item
        try {
          item.focus();
        } catch (error) {
          console.error('Error focusing dropdown item:', error);
        }

        // Also try to focus the input inside the li if it exists
        const input = item.querySelector('input[type="checkbox"]') as HTMLElement;
        if (input) {
          try {
            input.focus();
          } catch (error) {
            console.error('Error focusing checkbox input:', error);
          }
        }

        item.scrollIntoView({ block: 'nearest' });
      } else {
        
      }
    } else {
      
    }
  }

  private selectFocusedItem(dropdownId: string, dropdownElement: HTMLElement): void {
    
    
    const dropdownList = dropdownElement.querySelector('.c-list') as HTMLElement ||
                        dropdownElement.querySelector('.dropdown-list') as HTMLElement ||
                        dropdownElement.querySelector('.multiselect-list') as HTMLElement ||
                        dropdownElement.querySelector('[role="listbox"]') as HTMLElement;
    
    
    
    if (dropdownList && this.currentFocusedIndex >= 0) {
      // Use the same prioritized selectors
      const items = dropdownList.querySelectorAll('li.pure-checkbox, .c-option, .dropdown-item, .multiselect-item, [role="option"], li, .item, .option, .list-item');
      
      
      if (items.length > 0 && this.currentFocusedIndex < items.length) {
        const item = items[this.currentFocusedIndex] as HTMLElement;
        
        
        // Try multiple approaches to select the item
        try {
          // Method 1: Click the checkbox input directly
          const checkbox = item.querySelector('input[type="checkbox"]') as HTMLInputElement;
          if (checkbox) {
            
            checkbox.checked = !checkbox.checked;

            // Trigger change event
            const changeEvent = new Event('change', { bubbles: true });
            checkbox.dispatchEvent(changeEvent);

            // Trigger click event
            const clickEvent = new Event('click', { bubbles: true });
            checkbox.dispatchEvent(clickEvent);
            
            
          }

          // Method 2: Click the label if it exists
          const label = item.querySelector('label') as HTMLElement;
          if (label) {
            
            label.click();
          }

          // Method 3: Click the entire li element
          
          item.click();

          // Method 4: Try to trigger the component's selection method
          // Look for the multiselect component instance
          const multiselectComponent = (dropdownElement as any).__ngContext__;
          if (multiselectComponent) {
            
          }

          // Method 5: Manually trigger the filter change event for this dropdown
          setTimeout(() => {
            
            this.eventFilterChange('Customer');

            // Keep focus on the dropdown button after selection
            const dropdownButton = dropdownElement.querySelector('.c-btn') as HTMLElement ||
              dropdownElement.querySelector('.dropdown-btn') as HTMLElement ||
              dropdownElement.querySelector('.multiselect-dropdown') as HTMLElement ||
              dropdownElement.querySelector('[role="button"]') as HTMLElement;

            if (dropdownButton) {
              try {
                dropdownButton.focus();
              } catch (error) {
                console.error('Error focusing dropdown button:', error);
              }
            }
          }, 100);

        } catch (error) {
          console.error('Error selecting dropdown item:', error);
        }
      } else {
        
      }
    } else {
      
    }
  }

  // Method to focus the search input within the dropdown
  private focusSearchInput(dropdownElement: HTMLElement): void {
    
    
    // Try to find the search input - common selectors for search inputs in multiselect components
    const searchInput = dropdownElement.querySelector('input[type="text"]') as HTMLInputElement ||
                       dropdownElement.querySelector('input[placeholder*="search" i]') as HTMLInputElement ||
                       dropdownElement.querySelector('input[placeholder*="filter" i]') as HTMLInputElement ||
                       dropdownElement.querySelector('.search-input') as HTMLInputElement ||
                       dropdownElement.querySelector('.filter-input') as HTMLInputElement ||
                       dropdownElement.querySelector('input') as HTMLInputElement;
    
    
    
    if (searchInput) {
      try {
        searchInput.focus();
      } catch (error) {
        console.error('Error focusing search input:', error);
      }
    } else {
      
      // Fallback to focusing the first item if no search input is found
      this.focusDropdownItem(dropdownElement, 0);
    }
  }

  // Method to handle focus events on dropdowns
  onDropdownFocus(dropdownId: string): void {
    this.currentFocusedDropdown = dropdownId;
    this.currentFocusedIndex = -1;
  }

  // Method to handle blur events on dropdowns
  onDropdownBlur(dropdownId: string): void {
    if (this.currentFocusedDropdown === dropdownId) {
      this.currentFocusedDropdown = '';
      this.currentFocusedIndex = -1;
    }
  }
  
  toggleFilters() {
    this.filtersExpanded = !this.filtersExpanded;
  }
  fetchPdf(){
    this.downloadFiles.emit("pdfExport");
  }
  fetchExcel(){
    this.downloadFiles.emit("excelExport");
  }

}
